module.exports = {
    doublegame: {}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 31
// module chunks = 0